import LazyLoad from "vanilla-lazyload";
import objectFitImages from 'object-fit-images';

/* Init lazyload image */
const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
});

/* Init object fit cover for IE */
objectFitImages('img.img-full');


// WEBPACK FOOTER //
// ./assets/scripts/utils/_lazyload.js